module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lease-service"
  }, [_c('el-table', {
    staticClass: "table-shin-expand",
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-checkbox', {
          staticClass: "check-all",
          attrs: {
            "disabled": _vm.checkLotLines(props.row)
          },
          on: {
            "change": function($event) {
              _vm.handleCheckAllChange($event, props.row)
            }
          },
          model: {
            value: (_vm.multiCheck[props.row.LineId].checkAll),
            callback: function($$v) {
              _vm.multiCheck[props.row.LineId].checkAll = $$v
            },
            expression: "multiCheck[props.row.LineId].checkAll"
          }
        }, [_vm._v("全选")]), _vm._v(" "), _c('el-checkbox-group', {
          on: {
            "change": function($event) {
              _vm.handleCheckItemChange($event, props.row)
            }
          },
          model: {
            value: (_vm.multiCheck[props.row.LineId].checkedRow),
            callback: function($$v) {
              _vm.multiCheck[props.row.LineId].checkedRow = $$v
            },
            expression: "multiCheck[props.row.LineId].checkedRow"
          }
        }, _vm._l((props.row.LotLines), function(row) {
          return _c('div', {
            key: row.LotId,
            staticClass: "inner-list"
          }, [_c('el-checkbox', {
            key: row.LotId,
            staticClass: "checkbox",
            attrs: {
              "disabled": !!row.AfterSalesRequestType && row.AfterSalesRequestState !== 'cancelled',
              "label": row.LotId
            }
          }, [_vm._v(_vm._s(''))]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("批次号")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(row.LotCode))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item",
            staticStyle: {
              "text-align": "center"
            }
          }, [_c('el-tag', {
            staticStyle: {
              "margin-top": "8px"
            },
            attrs: {
              "type": "primary"
            }
          }, [_vm._v(_vm._s(row.ConditionName))])], 1), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("租赁周期：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(row.RentalPeriod) + "个月")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("折扣：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(row.DiscountRate * 100) + "%")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("租赁单价：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.RentalUnitPrice))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("保修：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.WarrantyAmount) + "/" + _vm._s(row.WarrantyMonths * 30) + "天")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("剩余保修时间：")]), _vm._v(" "), _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (row.WarrantyLeftDays > 0),
              expression: "row.WarrantyLeftDays > 0"
            }],
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(Math.round(row.WarrantyLeftDays)) + "天")]), _vm._v(" "), _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (row.WarrantyMonths !== 0 && row.WarrantyLeftDays <= 0),
              expression: "row.WarrantyMonths !== 0 && row.WarrantyLeftDays <= 0"
            }],
            staticClass: "no-margin",
            staticStyle: {
              "color": "#FF4949"
            }
          }, [_vm._v("过保")]), _vm._v(" "), _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (row.WarrantyMonths === 0),
              expression: "row.WarrantyMonths === 0"
            }],
            staticClass: "no-margin"
          }, [_vm._v("无")])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("租金：\n                "), _c('el-tooltip', {
            attrs: {
              "popper-class": "blue-tooltip",
              "effect": "dark",
              "content": "租赁单价*数量+保修费用",
              "placement": "top"
            }
          }, [_c('i', {
            staticClass: "el-icon-information"
          })])], 1), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v("￥" + _vm._s(row.RentalAmount))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("起租时间：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(_vm._f("date")(row.StartDate, 'YYYY/MM/DD')))])]), _vm._v(" "), _c('div', {
            staticClass: "list-item"
          }, [_c('label', [_vm._v("已租时长：")]), _vm._v(" "), _c('p', {
            staticClass: "no-margin"
          }, [_vm._v(_vm._s(Math.round(row.RentDays)) + "天")])]), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (row.AfterSalesRequestType || row.AfterSalesType),
              expression: "row.AfterSalesRequestType || row.AfterSalesType"
            }],
            staticClass: "list-item"
          }, [_c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: ((row.AfterSalesRequestType || row.AfterSalesType) === 'repair' && row.AfterSalesRequestState !== 'cancelled'),
              expression: "(row.AfterSalesRequestType || row.AfterSalesType) === 'repair' && row.AfterSalesRequestState !== 'cancelled'"
            }],
            attrs: {
              "type": "text"
            }
          }, [_vm._v("维修售后中")]), _vm._v(" "), _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: ((row.AfterSalesRequestType || row.AfterSalesType) === 'renewal' && row.AfterSalesRequestState !== 'cancelled'),
              expression: "(row.AfterSalesRequestType || row.AfterSalesType) === 'renewal' && row.AfterSalesRequestState !== 'cancelled'"
            }],
            attrs: {
              "type": "text"
            }
          }, [_vm._v("续租售后中")]), _vm._v(" "), _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: ((row.AfterSalesRequestType || row.AfterSalesType) === 'return' && row.AfterSalesRequestState !== 'cancelled'),
              expression: "(row.AfterSalesRequestType || row.AfterSalesType) === 'return' && row.AfterSalesRequestState !== 'cancelled'"
            }],
            attrs: {
              "type": "text"
            }
          }, [_vm._v("退还售后中")])])], 1)
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          staticClass: "no-margin"
        }, [_vm._v(_vm._s(props.row.ProductName))]), _vm._v(" "), _c('p', {
          staticClass: "no-margin"
        }, [_vm._v("物料编码：" + _vm._s(props.row.ProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户物料名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          staticClass: "no-margin"
        }, [_vm._v(_vm._s(props.row.CustomerProductName))]), _vm._v(" "), _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.CustomerProductCode),
            expression: "props.row.CustomerProductCode"
          }],
          staticClass: "no-margin"
        }, [_vm._v("物料编码：" + _vm._s(props.row.CustomerProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "prop": "BrandName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型",
      "prop": "ModelName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "prop": "ModuleName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "租赁数量",
      "prop": "RentalQuantity"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "保修期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row.WarrantyMonths) + "个月/" + _vm._s(props.row.WarrantyAmount) + "元")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "lease001",
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.handleRepairFormDialogOpen(props.row)
            }
          }
        }, [_vm._v("维修")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.handleRenewFormDialogOpen(props.row)
            }
          }
        }, [_vm._v("续租")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.handleReturnFormDialogOpen(props.row)
            }
          }
        }, [_vm._v("退还")])]
      }
    }])
  })], 1), _vm._v(" "), _c('repair-form-dialog', {
    attrs: {
      "show": _vm.repairFormDialog.show,
      "list": _vm.repairFormDialog.list
    },
    on: {
      "update:show": function($event) {
        _vm.repairFormDialog.show = $event
      },
      "confirm": _vm.handleConfirm
    }
  }), _vm._v(" "), _c('renew-form-dialog', {
    attrs: {
      "show": _vm.renewalFormDialog.show,
      "list": _vm.renewalFormDialog.list
    },
    on: {
      "update:show": function($event) {
        _vm.renewalFormDialog.show = $event
      },
      "confirm": _vm.handleConfirm
    }
  }), _vm._v(" "), _c('return-form-dialog', {
    attrs: {
      "show": _vm.returnFormDialog.show,
      "list": _vm.returnFormDialog.list
    },
    on: {
      "update:show": function($event) {
        _vm.returnFormDialog.show = $event
      },
      "confirm": _vm.handleConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40b3defa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Lease/LeaseDetailTableService.vue
// module id = 727
// module chunks = 0